import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { requireMenuOrRedirect } from '@/lib/auth/require-permission';

const PermissionsPage = lazy(() =>
  import('@/pages/ads/permissions/permissions-page').then((m) => ({ default: m.PermissionsPage })),
);

export const Route = createFileRoute('/_app/ads/permissions')({
  beforeLoad: requireMenuOrRedirect('menu:ads-admin:permissions', '/ads/accounts'),
  component: () => (
    <Suspense fallback={<div>加载中…</div>}>
      <PermissionsPage />
    </Suspense>
  ),
});
